import toolsClient from "@/api/toolsClient"
import { MULTIPART_HEADERS, buildEpisodeFormData } from "@/api/apiUtils"

export const getBotPodcastEpisodes = async (
  podcastKey,
  { limit = 10, search = "", offset = 0, order = "-publish_date" }
) => {
  const response = await toolsClient.get(`/podcast-bot/podcasts/${podcastKey}/episodes`, {
    params: { limit, offset, order, search: search || null },
  })

  return response.data
}

export const getBotPodcastEpisode = async (podcastKey, episodeKey) => {
  const response = await toolsClient.get(`/podcast-bot/podcasts/${podcastKey}/episodes/${episodeKey}`)

  return response.data
}

export const updateBotPodcastEpisode = async (episode) => {
  const response = await toolsClient.put(
    `/podcast-bot/podcasts/${episode.podcast}/episodes/${episode.key}`,
    buildEpisodeFormData(episode),
    MULTIPART_HEADERS
  )

  return response.data
}

export const deleteBotPodcastEpisode = async (podcastKey, episodeKey) => {
  await toolsClient.delete(`/podcast-bot/podcasts/${podcastKey}/episodes/${episodeKey}`)
}

export const deleteBotPodcastEpisodes = async (podcastKey, episodeKeys) => {
  await toolsClient.post(`/podcast-bot/podcasts/${podcastKey}/episodes/bulk-delete`, episodeKeys)
}
